'use client'

import { issueDescriptions } from '@/constants/issues';
import useHotelDetailStore from '@/core/stores/hotelDetail';
import { format } from 'date-fns';
import NavigateButton from '../NewComponents/NavigateButton';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/pro-regular-svg-icons';
import HotelBoxV2 from '../NewComponents/HotelBoxV2';
const regex = /[.](?=[A-Z ])/;
export default function Policies({ issues, navigateTo }: { issues?: any[], navigateTo: string }) {
    const { policies } = useHotelDetailStore()
    return (policies || (issues && issues.length > 0)) && (
        <HotelBoxV2 className='mt-3'>
            <HotelBoxV2.Header>
                Policies
            </HotelBoxV2.Header>
            <HotelBoxV2.Body>
                {<div id="policies" className="">
                    <h2 className="flex flex-row gap-2">
                        <span className="text-sm font-semibold text-neutral-800">
                            Things to keep in mind
                        </span>
                    </h2>
                    <ul className="flex list-disc flex-col gap-2 pl-2 pt-2 text-sm font-normal text-neutral-800">
                        <li className="whitespace-pre-wrap">
                            {policies
                                .replace('Rate Notes:\n\nHotel Tariff Notes:\n', '').replaceAll('&quot;', '')}
                        </li>


                    </ul>

                </div >}
            </HotelBoxV2.Body>
            <HotelBoxV2.Footer>
                <NavigateButton
                    actionMessage={'opened more policies '}
                    to={navigateTo}
                    className='text-secondary-500 text-xs flex items-center gap-2'>
                    See Policies of the Property
                    <FontAwesomeIcon icon={faChevronRight} />
                </NavigateButton>
            </HotelBoxV2.Footer>
        </HotelBoxV2>

    );
}